import { FC } from 'react';

import useSWR from 'swr';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { MailingTab } from './constants';
import { CreateCampaign } from './createCampaign/CreateCampaign';
import { MailingCampaigns } from './mailingCampaigns/MailingCampaigns';

import css from './MailingPage.module.css';

import { mailingService } from 'v2/api/mailingService';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { useTabs } from 'v2/hooks/useTabs';

export const MailingPage: FC = () => {
  const { activeTab, onTabChange } = useTabs<MailingTab>(MailingTab.CREATE);

  const { data: stats } = useSWR('getMailingStats', mailingService.getStats);

  const handleCreateCampaignSuccess = () => {
    onTabChange(MailingTab.CAMPAIGNS);
  };

  const handleTabChange = (_: unknown, tab: MailingTab) => {
    onTabChange(tab);
  };

  return (
    <PageLayout className={css.mailingPage} overflow="hidden">
      <div className={css.mailingPageHeader}>
        <PageTitle>Mailing</PageTitle>

        {stats && (
          <div className={css.statsCard}>
            <div className={css.statItem}>
              <span className={css.statLabel}>Total Campaigns</span>
              <span className={css.statValue}>{stats.totalCampaigns}</span>
            </div>
            <div className={css.statItem}>
              <span className={css.statLabel}>Messages Sent</span>
              <span className={css.statValue}>{stats.totalMessagesSent}</span>
            </div>
            <div className={css.statItem}>
              <span className={css.statLabel}>Messages Failed</span>
              <span className={css.statValue}>{stats.totalMessagesFailed}</span>
            </div>
          </div>
        )}
      </div>

      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab value={MailingTab.CREATE} label="Create Campaign" />
        <Tab value={MailingTab.CAMPAIGNS} label="Campaigns" />
      </Tabs>

      <div className={css.mailingPageContent}>
        {activeTab === MailingTab.CREATE && <CreateCampaign onSuccess={handleCreateCampaignSuccess} />}
        {activeTab === MailingTab.CAMPAIGNS && <MailingCampaigns />}
      </div>
    </PageLayout>
  );
};
